// @oasis-permission-inherits: /basecamp/evals (evals:view)
import { Link, createFileRoute } from "@tanstack/react-router";

import { Button } from "~/components/ui/button";
import { Skeleton } from "~/components/ui/skeleton";
import { BasecampEvalDetail } from "~/modules/basecamp-evals/eval-detail";
import { basecampPreviewDetails } from "~/modules/basecamp-evals/preview-fixture";
import { getBasecampEvalQuery } from "~/modules/basecamp-evals/queries";
import { usePageTitle } from "~/modules/page-title/page-title";

export const Route = createFileRoute("/_dash/basecamp/evals/$comparisonId")({
  component: EvalDetailPage,
});

function EvalDetailPage() {
  const { comparisonId } = Route.useParams();
  const previewDetail = import.meta.env.DEV ? basecampPreviewDetails[comparisonId] : undefined;
  const preview = Boolean(previewDetail);
  usePageTitle("Basecamp Eval");
  const {
    data: loadedData,
    error,
    isLoading,
    refetch,
    isFetching,
  } = getBasecampEvalQuery.useQuery(
    { params: { comparisonId } },
    { enabled: !preview, refetchInterval: 30_000 }
  );
  const data = previewDetail ?? loadedData;
  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between gap-3">
        <Link to="/basecamp/evals" className="text-sm text-muted-foreground underline">
          ← All Basecamp evals
        </Link>
        <Button
          variant="outline"
          size="sm"
          disabled={isFetching || preview}
          onClick={() => void refetch()}
        >
          Refresh
        </Button>
      </div>
      {preview && (
        <p className="rounded-lg border border-dashed p-3 text-sm text-muted-foreground">
          Development preview · synthetic measurements and trajectories, with sample playback media.
        </p>
      )}
      {isLoading && <Skeleton className="h-96 w-full" />}
      {error && (
        <p
          role="alert"
          className="rounded-lg border border-destructive p-4 text-sm text-destructive"
        >
          Could not load this comparison: {error.message}
        </p>
      )}
      {data && <BasecampEvalDetail detail={data} />}
    </div>
  );
}
